<div class="app-section" aria-labelledby="apps-title">
  <app-header-container
    [appDetails]="appDetails"
    [extraData]="extraData"
    (updateFavorite)="handleButtonClick($event)"
  ></app-header-container>

  @if (!loading) {
    <div class="items" [ngClass]="isNeedToProcessItems ? 'fav-items' : ''">
      @for (appDataItem of appsData; track appDataItem; let i = $index) {
        <div
          class="item"
          [class.border-dash]="hasDashBorder"
          [ngClass]="isNeedToProcessItems ? 'fav-item' : ''"
          (click)="clickApp(appDataItem, i)"
          (keydown.enter)="clickApp(appDataItem, i)"
          tabindex="0"
          role="button"
          [attr.aria-label]="appDataItem.name"
          [attr.data-testid]="appDataItem.name"
        >
          <mds-icon class="item__icon" [pathColors]="[appDataItem.color]" [key]="appDataItem.icon" [width]="32" [height]="32"></mds-icon>
          <div>
            <b class="title">{{ appDataItem.name }}</b>
            <p class="description">{{ appDataItem.description }}</p>
          </div>
        </div>
      }
    </div>
  }
  @if (isShowSeeMore && !loading) {
    <div
      class="more"
      (keydown.enter)="clickApp('Tools', null)"
      (click)="clickApp('Tools', null)"
      tabindex="0"
      role="button"
      aria-label="See more apps"
      [attr.data-testid]="'See more apps'"
      >
      See more apps
      <mds-icon [key]="icons.ARROW_FORWARD" [pathColors]="['#8A9DA8']"></mds-icon>
    </div>
  }
  @if (loading) {
    <mds-loader></mds-loader>
  }
</div>
